// RefineryTools.jsx
import React, { useMemo, useState, useRef } from 'react';

// 🔗 LINE + Firestore (สำหรับ HBD + Slots Modal)
import { initializeApp, getApps } from 'firebase/app';
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';

// --- Firebase (ตาม Reference) ---
const firebaseConfig = {
  apiKey: "AIzaSyBALO-oNqvxmRhTSx9S54A5PIilTrxVOYM",
  authDomain: "refinery-desk-dashboard.firebaseapp.com",
  projectId: "refinery-desk-dashboard",
  storageBucket: "refinery-desk-dashboard.firebasestorage.app",
  messagingSenderId: "28035012838",
  appId: "1:28035012838:web:eb80f171a10371cdbec327"
};
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
const db = getFirestore(app);

// ==============================
// RefineryTools
// - ปุ่มเรียก Modal เครื่องมือ
// - HBD (Tier + Nickname + Preview/Copy/Send)
// - Payment Helper (คำนวณส่วนลด)
// - Available Slots (Manual) — ปุ่มที่ 3
// ==============================

const TOOL_BUTTONS = [
  { id: 'PAYMENT-HELPER', title: 'Payment Helper', caption: 'คำนวณส่วนลด + สรุปหมายเหตุ' },
  { id: 'HBD-MSG', title: 'Happy Birthday (Tier)', caption: 'ส่ง HBD ตาม Tier + ใส่ชื่อเล่น' },
  { id: 'AVAILABLE-SLOTS', title: 'Available Slots', caption: 'สรุปเวลาว่างและส่งให้ลูกค้า' }, // ✅ ปุ่มที่ 3
];

const PCT_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 25, 30, 35, 40, 45, 50];

// เพิ่ม/แก้ประเภทส่วนลดได้ที่นี่
const DISCOUNT_LABELS = ['', 'KOL FOLLOWERS', 'INFLUENCER', 'BLACK TIER', 'BLACK REFER', 'SPECIAL BY MANAGER', 'PARTNER', 'PARNER FRIEND', 'PARNER FAMILY', 'EMPLOYEE'];

// ---------- Helper (ทั่วไป) ----------
function toNum(v) {
  const n = parseFloat(String(v).replace(/,/g, ''));
  return isNaN(n) ? 0 : n;
}
function round2(n) {
  return Math.round((n + Number.EPSILON) * 100) / 100;
}
function fmt(n) {
  return Number.isFinite(n)
    ? n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : '0.00';
}
// รับเฉพาะตัวเลขและจุดทศนิยม
function sanitizeDecimalInput(val) {
  let s = String(val ?? '').replace(/[^0-9.,]/g, '').replace(/,/g, '');
  const parts = s.split('.');
  if (parts.length > 2) s = parts[0] + '.' + parts.slice(1).join('');
  return s;
}

// ---------- LINE / Firestore helpers ----------
const logToFirestore = async (text, selectedCustomer) => {
  const latestCustomerInfo = selectedCustomer || {};
  await addDoc(collection(db, 'messages'), {
    from: 'me',
    role: 'me',
    userId: latestCustomerInfo?.userId || '',
    type: 'text',
    customer: text,
    createdAt: serverTimestamp(),
    displayName: latestCustomerInfo.displayName || 'Customer',
    pictureUrl: latestCustomerInfo.pictureUrl || '',
  });
};
const sendToLine = async (userId, text) => {
  const res = await fetch('https://therefineryclinic.herokuapp.com/sendToLine', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId, message: text }),
  });
  const result = await res.json();
  if (!result.success) throw new Error(result.error || 'ส่ง LINE ไม่สำเร็จ');
};

// ---------- สร้างข้อความ HBD ตาม Tier + ชื่อเล่น ----------
const buildHbdText = (tier, nickname) => {
  const name = (nickname || '').trim();
  const hi = name ? `คุณ${name}` : 'คุณลูกค้า';
  const COMMON_TAIL = [
    '\nหากมีรายละเอียดอยากสอบถามเพิ่มเติม ทักมาได้ตลอดเลยนะคะ',
    '\nขอบคุณที่ไว้วางใจให้ ดิ รีไฟน์เนอรี่คลินิก ดูแลค่ะ'
  ].join('\n');

  if (tier === 'Black') {
    return [
      `ทาง รีไฟน์เนอรี่ ขออวยพรวันเกิดล่วงหน้านะคะ${hi}`,
      `\nขอให้ปีนี้เป็นปีที่สุขภาพดี ผิวแน่นกระจ่างใส และทุกอย่างเป็นไปอย่างที่${hi}ตั้งใจนะคะ`,
      `\nสำหรับเดือนเกิดนี้ ${hi}จะได้รับบริการระดับพิเศษโดยสามารถเลือกได้ 1 อย่างจาก 3 รายการที่ทีมคุณหมอคัดไว้ให้โดยเฉพาะค่ะ`,
      `\n𝟭. 𝗨𝗹𝘁𝗿𝗮𝗳𝗼𝗿𝗺𝗲𝗿 𝗜𝗜𝗜 𝟮𝟬𝟬 𝗦𝗵𝗼𝘁𝘀`,
      `\n𝟮. 𝗥𝗲𝗳𝗶𝗻𝗲𝗿𝘆'𝘀 𝗠𝗲𝘀𝗼 𝗙𝗮𝘁 𝟭𝟬𝗺𝗹`,
      `\n𝟯. 𝗦𝗸𝗶𝗻 𝗥𝗲𝗳𝗶𝗻𝗲𝗺𝗲𝗻𝘁 𝗠𝗲𝘀𝗼𝘁𝗵𝗲𝗿𝗮𝗽𝘆`,
      `\nและทุกยอดใช้จ่ายของ${hi} จะได้รับคะแนนสะสมพิเศษ 𝘅𝟮 ด้วยค่ะ`,
      COMMON_TAIL
    ].join('\n');
  }
  if (tier === 'Silver') {
    return [
      `ทาง รีไฟน์เนอรี่ ขออวยพรวันเกิดล่วงหน้านะคะ${hi}`,
      `\nขอให้สุขภาพแข็งแรง ผิวสวยตลอดปีและทุกอย่างเป็นไปอย่างที่${hi}ตั้งใจนะคะ`,
      `\nสำหรับเดือนเกิดนี้ ${hi}จะได้รับบริการพิเศษโดยสามารถเลือกได้ 1 อย่างจาก 3 รายการที่ทีมคุณหมอคัดไว้ให้โดยเฉพาะค่ะ`,
      `\n𝟭. 𝗜𝗩 𝗗𝗿𝗶𝗽 𝗧𝗵𝗲𝗿𝗮𝗽𝘆 𝟭 𝗼𝗳 𝟳 𝗙𝗼𝗿𝗺𝘂𝗹𝗮`,
      `\n𝟮. 𝗧𝗿𝗲𝗮𝘁𝗺𝗲𝗻𝘁 𝟭 𝗦𝗲𝘀𝘀𝗶𝗼𝗻`,
      `\n𝟯. 𝗟𝗮𝘀𝗲𝗿 𝗧𝗿𝗲𝗮𝘁𝗺𝗲𝗻𝘁 𝟭 𝗦𝗲𝘀𝘀𝗶𝗼𝗻`,
      `\nและทุกยอดใช้จ่ายของ${hi} จะได้รับคะแนนสะสมพิเศษ 𝘅𝟮 ด้วยค่ะ`,
      COMMON_TAIL
    ].join('\n');
  }
  // Bronze (default)
  return [
    `ทาง รีไฟน์เนอรี่ ขออวยพรวันเกิดล่วงหน้านะคะ${hi}`,
    `\nขอให้สุขภาพแข็งแรง ผิวสวยตลอดปีและทุกอย่างเป็นไปอย่างที่${hi}ตั้งใจนะคะ`,
    `\nสำหรับเดือนเกิดนี้ ทุกยอดใช้จ่ายของ${hi} จะได้รับคะแนนสะสมพิเศษ 𝘅𝟮 ตลอดทั้งเดือนเลยค่ะ`,
    COMMON_TAIL
  ].join('\n');
};

// ---------- Config สำหรับปุ่ม #3: Available Slots ----------
const BRANCHES = ['เพชรบุรี-ทองหล่อ']; // ขยายภายหลังได้
const DOCTORS_BY_BRANCH = {
  'เพชรบุรี-ทองหล่อ': ['หมอบอม', 'หมอเกริก', 'หมอแพตตี้'],
};
const ALL_DOCTORS = Array.from(new Set(Object.values(DOCTORS_BY_BRANCH).flat()));

const BRANCH_EN_BY_TH = {
  'เพชรบุรี-ทองหล่อ': 'Phetchaburi-Thonglor',
  // ถ้ามีสาขาอื่น เพิ่ม mapping ตรงนี้ได้เลยค่ะ
};

const DOCTOR_EN_BY_TH = {
  'หมอบอม': 'Doctor Bom',
  'หมอเกริก': 'Doctor Kerk',
  'หมอแพตตี้': 'Doctor Patty',
  // เพิ่มชื่อหมอคนอื่น ๆ ได้เลยค่ะ
};


const HOURS = Array.from({ length: 9 }, (_, i) => 12 + i); // 10..20
const MINUTES = [0, 20, 40];
const pad2 = (n) => String(n).padStart(2, '0');
const toTime = (h, m) => `${pad2(h)}:${pad2(m)}`;

// Date helpers (TH / EN)
const THAI_DAYS = ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'];
const THAI_MONTHS_SHORT = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'];

const EN_DAYS_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const EN_MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const todayInput = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = pad2(d.getMonth() + 1);
  const day = pad2(d.getDate());
  return `${y}-${m}-${day}`;
};
const inputToDate = (s) => {
  if (!s) return null;
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y, m - 1, d);
};
const formatThaiDate = (s) => {
  const dt = inputToDate(s);
  if (!dt) return '';
  const dow = `วัน${THAI_DAYS[dt.getDay()]}`;
  return `${dow} ${dt.getDate()} ${THAI_MONTHS_SHORT[dt.getMonth()]} ${dt.getFullYear()}`;
};
const formatEnglishDate = (s) => {
  const dt = inputToDate(s);
  if (!dt) return '';
  const dow = EN_DAYS_SHORT[dt.getDay()];
  return `${dow} ${dt.getDate()} ${EN_MONTHS_SHORT[dt.getMonth()]} ${dt.getFullYear()}`;
};

// รวมชั่วโมงติดกันให้เป็นช่วงเดียว
function compressConsecutiveHours(hours) {
  if (!hours.length) return [];
  const sorted = [...hours].sort((a, b) => a - b);
  const ranges = [];
  let start = sorted[0];
  let prev = sorted[0];
  for (let i = 1; i < sorted.length; i++) {
    const h = sorted[i];
    if (h === prev + 1) {
      prev = h;
    } else {
      ranges.push([start, prev]);
      start = prev = h;
    }
  }
  ranges.push([start, prev]);
  return ranges;
}

// TH: เรียงและขึ้นบรรทัดใหม่ทีละช่วง/เวลา + ใส่วัน/วันที่ (รองรับ "วันนี้")
function buildSlotsMessageTH({ nickname, branch, doctor, selection, dateLabel }) {
  const name = (nickname || '').trim();
  const hi = name ? `คุณ${name}` : 'คุณลูกค้า';

  // เตรียมข้อมูลเวลา
  const hours = Object.keys(selection)
    .map(Number)
    .filter((h) => (selection[h] || []).length > 0);

  const fullHours = [];
  const partialTimes = [];
  for (const h of hours) {
    const mins = [...(selection[h] || [])].sort((a, b) => a - b);
    const isFull = MINUTES.every((m) => mins.includes(m));
    if (isFull) {
      fullHours.push(h);
    } else {
      mins.forEach((m) => partialTimes.push({ h, m, label: toTime(h, m), sort: h * 60 + m }));
    }
  }

  // แปลง fullHours เป็นช่วง HH:00 - HH:40 และรวมชั่วโมงต่อเนื่อง
  const fullRanges = compressConsecutiveHours(fullHours).map(([s, e]) => ({
    sort: s * 60,
    label: `${pad2(s)}:00 - ${pad2(e)}:40`,
  }));

  // รวมทั้งหมดเข้าด้วยกันแล้วเรียงเวลา
  const entries = [...fullRanges, ...partialTimes].sort((a, b) => a.sort - b.sort);

  const when = entries.length
    ? entries.map((e) => `• ${e.label}`).join('\n')
    : '(รอเลือกระบุเวลาว่าง)';

  const isToday = dateLabel === 'วันนี้';

  // สร้างหัวข้อความตามเงื่อนไข
  let header = '';
  if (isToday) {
    if (branch) {
      // ตัวอย่างที่ต้องการ:
      // วันนี้ที่สาขา เพชรบุรี-ทองหล่อ
      // (ถ้ามีคุณหมอ ให้ขึ้นบรรทัดถัดไป)
      // มีช่วงเวลาคิวว่างตามนี้ค่ะ
      header =
        `วันนี้ที่สาขา ${branch}` +
        (doctor ? `\nจะเป็นคุณ${doctor} นะคะ` : '') +
        `\n\nมีช่วงเวลาคิวว่างตามนี้ค่ะ\n`;
    } else {
      // ตัวอย่างที่ต้องการ:
      // วันนี้มีช่วงเวลาคิวว่างตามนี้ค่ะ
      // (หากมีหมอและอยากให้แจ้งไว้ด้านบน ให้เติมบรรทัด doctor ก่อนหน้าบรรทัดวันนี้ได้)
      header =
        `วันนี้` +
        (doctor ? `จะเป็นคุณ${doctor} นะคะ\n` : '') +
        `มีช่วงเวลาคิวว่างตามนี้ค่ะ\n`;
    }
  } else {
    // กรณีระบุเป็นวันที่ทั่วไป ให้ขึ้นรูปแบบ: "<วันที่> ที่สาขา ... (ถ้ามีหมอ) ... "
    // แล้วตามด้วยบรรทัด "มีช่วงเวลาคิวว่างตามนี้ค่ะ"
    const firstLine = [
      dateLabel ? `${dateLabel}` : '',
      branch ? `\nที่สาขา ${branch}` : '',
      doctor ? `\nจะเป็นคุณ${doctor} นะคะ` : ''
    ].filter(Boolean).join(' ');
    header = `${firstLine}\n\nมีช่วงเวลาคิวว่างตามนี้ค่ะ\n`;
  }

  return [
    header,
    when,
    `\n${hi}สนใจเป็นช่วงเวลาใดดีคะ แอดมินดำเนินการลงคิวที่${hi}สะดวกที่สุดให้ค่ะ`,
  ].join('\n');
}

// EN: เวอร์ชันภาษาอังกฤษ (รองรับ "today")
function buildSlotsMessageEN({ nickname, branch, doctor, selection, dateLabelEN }) {
  const name = (nickname || '').trim();
  const hi = name ? `Khun ${name}, ` : '';

  // times
  const hours = Object.keys(selection)
    .map(Number)
    .filter((h) => (selection[h] || []).length > 0);

  const fullHours = [];
  const partialTimes = [];
  for (const h of hours) {
    const mins = [...(selection[h] || [])].sort((a, b) => a - b);
    const isFull = MINUTES.every((m) => mins.includes(m));
    if (isFull) {
      fullHours.push(h);
    } else {
      mins.forEach((m) => partialTimes.push({ h, m, label: toTime(h, m), sort: h * 60 + m }));
    }
  }

  const fullRanges = compressConsecutiveHours(fullHours).map(([s, e]) => ({
    sort: s * 60,
    label: `${pad2(s)}:00 - ${pad2(e)}:40`,
  }));

  const entries = [...fullRanges, ...partialTimes].sort((a, b) => a.sort - b.sort);

  const when = entries.length
    ? entries.map((e) => `• ${e.label}`).join('\n')
    : '(รอเลือกระบุเวลาว่าง)';

  // แทนที่บล็อก English เดิมด้วยบล็อกนี้

  const isTodayEN = (dateLabelEN || '').toLowerCase() === 'today';

  // แปลงชื่อสาขา/คุณหมอเป็น EN ตาม mapping
  const branchEN = branch ? (BRANCH_EN_BY_TH[branch] || branch) : '';
  const doctorEN = doctor ? (DOCTOR_EN_BY_TH[doctor] || doctor) : '';

  // สร้างหัวข้อภาษาอังกฤษตามเงื่อนไข (ให้โครงเหมือน TH stable)
  let header = '';
  if (isTodayEN) {
    if (branchEN) {
      // Today + มีสาขา: ถ้ามีหมอ => ต่อท้ายในบรรทัดเดียวกัน
      header =
        `for Today, at our ${branchEN} branch` +
        (doctorEN ? ` with ${doctorEN}` : '') +
        `\n\nHere are the available time slots:\n`;
    } else {
      // Today + ไม่มีสาขา: รูปแบบเดิม
      header =
        `for Today,` +
        (doctorEN ? ` with ${doctorEN}\n` : `\n`) +
        `Here are the available time slots:\n`;
    }
  } else {
    // ไม่ใช่ Today: บรรทัดแรกเป็นวันที่, บรรทัดถัดไป
    // ถ้ามีทั้งสาขา+หมอ => รวมบรรทัดเดียวกัน
    let firstLine = dateLabelEN ? `${dateLabelEN}` : '';
    if (branchEN && doctorEN) {
      firstLine += `\nat our ${branchEN} branch with ${doctorEN}`;
    } else {
      if (branchEN) firstLine += `\nat our ${branchEN} branch`;
      if (doctorEN) firstLine += `\nwith ${doctorEN}`;
    }
    header = `${firstLine}\n\nHere are the available time slots:\n`;
  }

  return [
    header,
    when,
    `\n${hi}please let us know which time works best for you and we will reserve it right away.`,
  ].join('\n');
    
}

export default function RefineryTools({ onBack, userId, selectedCustomer }) {
  const [activeToolId, setActiveToolId] = useState(null);

  // ---------- STATE: HBD Modal ----------
  const [hbdTier, setHbdTier] = useState('Bronze'); // Bronze | Silver | Black
  const [hbdNick, setHbdNick] = useState('');
  const hbdPreview = useMemo(() => buildHbdText(hbdTier, hbdNick), [hbdTier, hbdNick]);
  const [hbdSending, setHbdSending] = useState(false);

  // ---------- STATE: AVAILABLE SLOTS Modal (Manual) ----------
  const [slotNick, setSlotNick] = useState('');
  const [slotBranch, setSlotBranch] = useState(''); // ✅ ไม่ระบุเป็นค่าเริ่มต้น
  const [slotDoctor, setSlotDoctor] = useState(''); // optional
  const [slotDate, setSlotDate] = useState(() => todayInput());
  const [useTodayWord, setUseTodayWord] = useState(false); // ✅ ปุ่ม "วันนี้" กดแล้วจะย่อใน Preview

  // selection: { [hour]: number[] } minutes in [0,20,40]
  const [slotSel, setSlotSel] = useState({});
  const isHourFull = (h) => (slotSel[h]?.length === 3 && MINUTES.every((m) => slotSel[h].includes(m)));
  const toggleMinute = (h, m) => {
    setSlotSel((prev) => {
      const cur = new Set(prev[h] || []);
      cur.has(m) ? cur.delete(m) : cur.add(m);
      return { ...prev, [h]: Array.from(cur).sort((a, b) => a - b) };
    });
  };
  const toggleFullHour = (h) => {
    setSlotSel((prev) => {
      const full = isHourFull(h);
      return { ...prev, [h]: full ? [] : [...MINUTES] };
    });
  };
  const clearAllSlots = () => setSlotSel({});

  // ภาษา Preview: 'TH' | 'EN'
  const [previewLang, setPreviewLang] = useState('TH');

  const slotDateLabelTH = useMemo(
    () => (useTodayWord ? 'วันนี้' : formatThaiDate(slotDate)),
    [slotDate, useTodayWord]
  );
  const slotDateLabelEN = useMemo(
    () => (useTodayWord ? 'today' : formatEnglishDate(slotDate)),
    [slotDate, useTodayWord]
  );

  const slotsPreviewTH = useMemo(
    () => buildSlotsMessageTH({
      nickname: slotNick,
      branch: slotBranch,
      doctor: slotDoctor,
      selection: slotSel,
      dateLabel: slotDateLabelTH
    }),
    [slotNick, slotBranch, slotDoctor, slotSel, slotDateLabelTH]
  );

  const slotsPreviewEN = useMemo(
    () => buildSlotsMessageEN({
      nickname: slotNick,
      branch: slotBranch,
      doctor: slotDoctor,
      selection: slotSel,
      dateLabelEN: slotDateLabelEN
    }),
    [slotNick, slotBranch, slotDoctor, slotSel, slotDateLabelEN]
  );

  const visiblePreview = previewLang === 'EN' ? slotsPreviewEN : slotsPreviewTH;

  const [slotsSending, setSlotsSending] = useState(false);
  const [toast, setToast] = useState(''); // success message (overlay)

  // ---------- PAYMENT-HELPER state ----------
  const [itemsCount, setItemsCount] = useState(1); // 1..8
  const [items, setItems] = useState(
    Array.from({ length: 8 }, () => ({ price: '', pct: '', pctLabel: '' }))
  );

  // Toggle sections (ค่าเริ่มต้น: Voucher ซ่อน)
  const [showVouchers, setShowVouchers] = useState(false);
  const [showCampaigns, setShowCampaigns] = useState(false);

  // Cash Voucher 3 ช่อง + โค้ด
  const [voucher1, setVoucher1] = useState('');
  const [voucher2, setVoucher2] = useState('');
  const [voucher3, setVoucher3] = useState('');
  const [voucher1Code, setVoucher1Code] = useState('');
  const [voucher2Code, setVoucher2Code] = useState('');
  const [voucher3Code, setVoucher3Code] = useState('');

  // Campaign 3 ชุด (Name + Code)
  const [camp1Name, setCamp1Name] = useState('');
  const [camp2Name, setCamp2Name] = useState('');
  const [camp3Name, setCamp3Name] = useState('');
  const [camp1Code, setCamp1Code] = useState('');
  const [camp2Code, setCamp2Code] = useState('');
  const [camp3Code, setCamp3Code] = useState('');

  // โอนจอง + ค่าชำระโดย (กำหนดเองบางช่อง)
  const [depositPaid, setDepositPaid] = useState(false);
  const DEPOSIT_AMOUNT = 500;

  // ชำระโดย: อนุญาตแก้ "เงินสด" และ "เครดิต" เอง — ระบบคำนวณ "โอนเงิน" อัตโนมัติ
  const [cashPayInput, setCashPayInput] = useState('');     // text
  const [creditPayInput, setCreditPayInput] = useState(''); // text

  const cashPay = useMemo(() => round2(toNum(cashPayInput)), [cashPayInput]);
  const creditPay = useMemo(() => round2(toNum(creditPayInput)), [creditPayInput]);

  const voucherTotalRaw = useMemo(
    () => round2(toNum(voucher1) + toNum(voucher2) + toNum(voucher3)),
    [voucher1, voucher2, voucher3]
  );
  const voucherTotal = showVouchers ? voucherTotalRaw : 0;

  // กระจาย Voucher เป็น "สตางค์รวมครบ" ให้ทุกรายการ โดยให้รายการท้ายรับส่วนต่าง
  const voucherAllocations = useMemo(() => {
    const n = Math.max(1, itemsCount);
    if (!showVouchers) return Array(n).fill(0);
    const totalCents = Math.round(voucherTotal * 100);
    if (totalCents <= 0) return Array(n).fill(0);
    const base = Math.floor(totalCents / n);
    const rem = totalCents - base * n;
    const arr = Array(n).fill(base);
    for (let k = 0; k < rem; k++) {
      const idx = n - 1 - k;
      arr[idx] += 1;
    }
    return arr.map(c => round2(c / 100));
  }, [voucherTotal, itemsCount, showVouchers]);

  const visibleItems = useMemo(() => items.slice(0, itemsCount), [items, itemsCount]);

  const computedRows = useMemo(() => {
    return visibleItems.map((it, i) => {
      const price = toNum(it.price);
      const pct = toNum(it.pct); // 0..50
      const pctDiscount = round2(price * pct / 100);
      const voucherShare = voucherAllocations[i] || 0;
      const totalDiscount = round2(pctDiscount + voucherShare);
      const net = round2(price - totalDiscount);
      return { price, pct, pctDiscount, voucherShare, totalDiscount, net, pctLabel: it.pctLabel || '' };
    });
  }, [visibleItems, voucherAllocations]);

  const totals = useMemo(() => {
    const sumPrice = computedRows.reduce((acc, r) => acc + r.price, 0);
    const sumPctDiscount = computedRows.reduce((acc, r) => acc + r.pctDiscount, 0);
    const sumVoucherAlloc = computedRows.reduce((acc, r) => acc + r.voucherShare, 0);
    const sumTotalDiscount = round2(sumPctDiscount + sumVoucherAlloc);
    const sumNet = round2(sumPrice - sumTotalDiscount);
    const netAfterDeposit = round2(Math.max(0, sumNet - (depositPaid ? DEPOSIT_AMOUNT : 0)));
    return {
      sumPrice: round2(sumPrice),
      sumPctDiscount: round2(sumPctDiscount),
      sumVoucherAlloc: round2(sumVoucherAlloc),
      sumTotalDiscount,
      sumNet,
      netAfterDeposit
    };
  }, [computedRows, depositPaid]);

  const transferPay = useMemo(() => {
    const remain = round2(totals.netAfterDeposit - cashPay - creditPay);
    return remain < 0 ? 0 : remain;
  }, [totals.netAfterDeposit, cashPay, creditPay]);

  const overpay = useMemo(() => {
    return cashPay + creditPay > totals.netAfterDeposit;
  }, [cashPay, creditPay, totals.netAfterDeposit]);

  const resetPaymentHelper = () => {
    setItemsCount(1);
    setItems(Array.from({ length: 8 }, () => ({ price: '', pct: '', pctLabel: '' })));
    setShowVouchers(false);
    setShowCampaigns(false);
    setVoucher1(''); setVoucher2(''); setVoucher3('');
    setVoucher1Code(''); setVoucher2Code(''); setVoucher3Code('');
    setCamp1Name(''); setCamp2Name(''); setCamp3Name('');
    setCamp1Code(''); setCamp2Code(''); setCamp3Code('');
    setDepositPaid(false);
    setCashPayInput('');
    setCreditPayInput('');
  };

  const resetHbdForm = () => {
    setHbdTier('Bronze');
    setHbdNick('');
  };

  const resetSlotsForm = () => {
    setSlotNick('');
    setSlotBranch(''); // ✅ reset เป็นไม่ระบุ
    setSlotDoctor('');
    setSlotDate(todayInput());
    setUseTodayWord(false);
    setSlotSel({});
    setPreviewLang('TH');
  };

  const openTool = (id) => {
    if (id === 'PAYMENT-HELPER') {
      resetPaymentHelper();
    }
    if (id === 'HBD-MSG') {
      resetHbdForm();
    }
    if (id === 'AVAILABLE-SLOTS') {
      resetSlotsForm();
    }
    setActiveToolId(id);
  };

  const scrollRef = useRef(null);
  const getScrollableParent = (el) => {
    let node = el;
    while (node && node !== document.body) {
      const { overflowY } = window.getComputedStyle(node);
      if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) return node;
      node = node.parentElement;
    }
    return window;
  };
  const scrollToTop = () => {
    const target = getScrollableParent(scrollRef.current);
    (target === window ? window : target).scrollTo({ top: 0, behavior: 'smooth' });
  };

  // ---------- สรุปหมายเหตุ ----------
  const notesText = useMemo(() => {
    const lines = [];
    if (showCampaigns) {
      const campaigns = [
        { name: camp1Name.trim(), code: camp1Code.trim() },
        { name: camp2Name.trim(), code: camp2Code.trim() },
        { name: camp3Name.trim(), code: camp3Code.trim() },
      ].filter(c => c.name || c.code);
      if (campaigns.length) {
        campaigns.forEach(({ name, code }) => {
          const title = name ? `แลกสิทธิ์แคมเปญ ${name}` : 'แลกสิทธิ์แคมเปญ';
          lines.push(title);
          if (code) lines.push(`#${code}`);
          lines.push('');
        });
      }
    }

    const discountPairsMap = new Map();
    computedRows.forEach(r => {
      const pct = r.pct;
      const label = (r.pctLabel || '').trim();
      if (pct > 0 && label) {
        const key = `${label}__${pct}`;
        discountPairsMap.set(key, { label, pct });
      }
    });
    const discountPairs = Array.from(discountPairsMap.values());
    if (discountPairs.length) {
      lines.push('ส่วนลด');
      discountPairs.forEach(({ label, pct }) => {
        lines.push(`${label} ${pct}%`);
      });
      lines.push('');
    }

    if (showVouchers) {
      const vCodes = [voucher1Code, voucher2Code, voucher3Code].map(s => s.trim()).filter(Boolean);
      if (voucherTotalRaw > 0 || vCodes.length) {
        lines.push('ส่วนลด');
        lines.push('Cash Voucher');
        if (voucherTotalRaw > 0) lines.push(`มูลค่ารวม ${fmt(voucherTotalRaw)} บาท`);
        vCodes.forEach(code => lines.push(`#${code}`));
        lines.push('');
      }
    }

    if (depositPaid) {
      lines.push(`โอนจองมา ${DEPOSIT_AMOUNT.toLocaleString()} บาท`);
    }

    return lines.join('\n').trim();
  }, [
    showCampaigns, camp1Name, camp2Name, camp3Name, camp1Code, camp2Code, camp3Code,
    showVouchers, voucher1Code, voucher2Code, voucher3Code, voucherTotalRaw,
    computedRows, depositPaid
  ]);

  const copyNotes = async () => {
    try {
      await navigator.clipboard.writeText(notesText);
      setToast('คัดลอกสรุปหมายเหตุแล้ว');
      setTimeout(() => setToast(''), 1400);
    } catch (e) {
      console.error('Copy failed', e);
    }
  };

  // ---------- HBD Handlers ----------
  const copyHbd = async () => {
    try {
      await navigator.clipboard.writeText(hbdPreview);
      setToast('คัดลอกข้อความ HBD แล้ว');
      setTimeout(() => setToast(''), 1400);
    } catch (e) {
      console.error('Copy HBD failed', e);
    }
  };

  const sendHbd = async () => {
    if (!userId) return;
    try {
      setHbdSending(true);
      await sendToLine(userId, hbdPreview);
      await logToFirestore(hbdPreview, selectedCustomer);
      setToast('ส่ง HBD สำเร็จ');
      setTimeout(() => setToast(''), 1800);
      setActiveToolId(null);
    } catch (err) {
      console.error('❌ LINE ERROR:', err);
      alert('❌ ไม่สามารถส่งข้อความผ่าน LINE ได้');
    } finally {
      setHbdSending(false);
    }
  };

  // ---------- Available Slots Handlers ----------
  const copySlots = async () => {
    try {
      await navigator.clipboard.writeText(visiblePreview);
      setToast('คัดลอกข้อความเวลาว่างแล้ว');
      setTimeout(() => setToast(''), 1400);
    } catch (e) {
      console.error('Copy slots failed', e);
    }
  };

  const sendSlots = async () => {
    if (!userId) return;
    try {
      setSlotsSending(true);
      await sendToLine(userId, visiblePreview); // ✅ ส่งตามภาษาที่แสดง
      await logToFirestore(visiblePreview, selectedCustomer);
      setToast('ส่งสรุปเวลาว่างแล้ว');
      setTimeout(() => setToast(''), 1800);
      setActiveToolId(null);
    } catch (err) {
      console.error('❌ LINE ERROR:', err);
      alert('❌ ไม่สามารถส่งข้อความผ่าน LINE ได้');
    } finally {
      setSlotsSending(false);
    }
  };

  return (
    <div ref={scrollRef} className="relative max-w-screen-xl mx-auto">
      {/* Header */}
      <div className="flex justify-between items-center mt-[-2px] mb-4">
        <div className="flex items-center gap-3">
          <h3 className="text-lg font-semibold">Refinery Tools</h3>
          {onBack && (
            <button
              onClick={onBack}
              className="px-2 py-1 text-xs rounded-full border border-gray-300 text-gray-600 bg-gray-100 hover:bg-gray-200 transition"
            >
              ← Back
            </button>
          )}
        </div>
      </div>

      {/* Buttons grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {TOOL_BUTTONS.map((b) => (
          <div key={b.id} className="border border-gray-200 rounded-xl p-4 bg-white shadow-sm hover:shadow transition">
            <div className="flex items-start justify-between gap-3">
              <div className="text-left">
                <div className="text-sm font-semibold leading-snug">{b.title}</div>
                {b.caption && <div className="text-xs text-gray-500 mt-0.5">{b.caption}</div>}
              </div>
              <button
                type="button"
                className="px-3 py-1 text-xs rounded-full border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                onClick={() => openTool(b.id)}
                title="Open"
              >
                Open
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Footer Controls */}
      <div className="mt-6 flex justify-end items-center">
        <button
          onClick={scrollToTop}
          className="px-2 py-1 text-xs rounded-full border border-gray-300 text-gray-600 bg-gray-100 hover:bg-gray-200 transition"
        >
          ↑ Top
        </button>
      </div>

      {/* ---------------- HBD MODAL ---------------- */}
      {activeToolId === 'HBD-MSG' && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-xl w-[92vw] max-w-[720px] p-5 max-h-[92vh] flex flex-col">
            {/* Header inside modal */}
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="text-sm font-semibold">Happy Birthday (Tier)</div>
                <div className="text-xs text-gray-500">Select Tier and Name to Send</div>
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setActiveToolId(null)}
                  className="px-2 py-1 text-xs rounded-full border border-gray-300 text-gray-600 hover:bg-gray-100"
                >
                  ✕ Close
                </button>
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto mt-4 space-y-4 pr-1">
              {/* Tier */}
              <div className="border rounded-xl p-4 bg-gray-50 border-gray-200">
                <div className="text-sm font-medium text-gray-900 mb-2">Tier</div>
                <div className="grid grid-cols-3 gap-2">
                  {['Bronze', 'Silver', 'Black'].map(t => (
                    <button
                      key={t}
                      type="button"
                      onClick={() => setHbdTier(t)}
                      className={`px-3 py-2 text-sm rounded-lg border transition ${hbdTier === t
                        ? 'bg-black text-white border-black'
                        : 'bg-white text-gray-800 border-gray-300 hover:bg-gray-100'
                        }`}
                      aria-pressed={hbdTier === t}
                    >
                      {t}
                    </button>
                  ))}
                </div>
              </div>

              {/* Nickname */}
              <div className="border rounded-xl p-4 bg-gray-50 border-gray-200">
                <label className="block text-sm font-medium text-gray-900 mb-1">Customer Name / Nickname</label>
                <input
                  type="text"
                  value={hbdNick}
                  onChange={(e) => setHbdNick(e.target.value)}
                  placeholder="Ex. อรยา / มีนา"
                  className="w-full border rounded-lg px-3 py-2 text-sm bg-white"
                />
              </div>

              {/* Preview */}
              <div className="border rounded-xl p-4 bg-gray-50 border-gray-200">
                <div className="flex items-center justify-between mb-2">
                  <div className="text-sm font-medium text-gray-900">Preview</div>
                  <button
                    onClick={copyHbd}
                    className="px-3 py-1 text-xs rounded-full border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                  >
                    Copy
                  </button>
                </div>
                <textarea
                  rows={10}
                  readOnly
                  value={hbdPreview}
                  className="w-full border rounded-lg px-3 py-2 text-sm bg-white"
                />
              </div>
            </div>

            {/* Footer actions */}
            <div className="mt-4 flex items-center justify-end gap-3">
              <button
                onClick={() => setActiveToolId(null)}
                className="px-4 py-1 text-sm rounded-full border border-gray-300 text-gray-700 hover:bg-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={sendHbd}
                disabled={!userId || hbdSending}
                className={`px-4 py-1 text-sm rounded-full transition ${!userId || hbdSending ? 'bg-gray-300 text-white cursor-not-allowed' : 'bg-black text-white hover:opacity-90'
                  }`}
                title={!userId ? 'ยังไม่มี userId ลูกค้าในหน้านี้' : 'ส่งไป LINE ลูกค้า'}
              >
                {hbdSending ? 'Sending…' : 'Send'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ---------------- AVAILABLE SLOTS MODAL (Manual) ---------------- */}
      {activeToolId === 'AVAILABLE-SLOTS' && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-xl w-[92vw] md:w-[88vw] lg:w-[72vw] xl:w-[64vw] max-w-[900px] p-5 max-h-[86vh] flex flex-col">

            {/* Header inside modal */}
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="text-sm font-semibold">Available Slots</div>
                <div className="text-xs text-gray-500">ดูเวลาจาก DoctorEase แล้วสรุปเวลาว่างเพื่อส่งให้ลูกค้า</div>
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setActiveToolId(null)}
                  className="px-2 py-1 text-xs rounded-full border border-gray-300 text-gray-600 hover:bg-gray-100"
                >
                  ✕ Close
                </button>
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto mt-4 space-y-4 pr-1">
              {/* Row: Customer + Branch + Doctor  → ทำให้เท่ากันทั้ง 3 คอลัมน์ */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                <div className="border rounded-xl p-4 bg-gray-50 border-gray-200">
                  <label className="block text-sm font-medium text-gray-900 mb-1">Customer Name</label>
                  <input
                    type="text"
                    value={slotNick}
                    onChange={(e) => setSlotNick(e.target.value)}
                    placeholder="ใส่ชื่อลูกค้า"
                    className="w-full border rounded-lg px-3 py-2 text-sm bg-white"
                  />
                </div>

                <div className="border rounded-xl p-4 bg-gray-50 border-gray-200">
                  <label className="block text-sm font-medium text-gray-900 mb-1">Branch (Optional)</label>
                  <select
                    value={slotBranch}
                    onChange={(e) => {
                      setSlotBranch(e.target.value);
                      setSlotDoctor(''); // reset doctor เมื่อเปลี่ยนสาขา
                    }}
                    className="w-full border rounded-lg px-3 py-2 text-sm bg-white"
                  >
                    <option value="">— Not Selected —</option>
                    {BRANCHES.map((b) => <option key={b} value={b}>{b}</option>)}
                  </select>
                </div>

                <div className="border rounded-xl p-4 bg-gray-50 border-gray-200">
                  <label className="block text-sm font-medium text-gray-900 mb-1">Doctor (Optional)</label>
                  <select
                    value={slotDoctor}
                    onChange={(e) => setSlotDoctor(e.target.value)}
                    className="w-full border rounded-lg px-3 py-2 text-sm bg-white"
                  >
                    <option value="">— Not Selected —</option>
                    {(slotBranch ? DOCTORS_BY_BRANCH[slotBranch] : ALL_DOCTORS).map((d) => (
                      <option key={d} value={d}>{d}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Time Selector: 10:00 - 20:00 / :00 :20 :40 (3 Columns) */}
              <div className="border rounded-xl p-4 bg-gray-50 border-gray-200">
                {/* ⏱️ ลำดับแรก: วันที่นัด + ปุ่มวันนี้ */}
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <div className="flex items-center gap-2">
                    <div className="text-sm font-medium text-gray-900">Appointment Date</div>
                    <input
                      type="date"
                      value={slotDate}
                      onChange={(e) => { setSlotDate(e.target.value); setUseTodayWord(false); }}
                      className="border rounded-lg px-3 py-2 text-sm bg-white"
                    />
                    <button
                      type="button"
                      onClick={() => { setSlotDate(todayInput()); setUseTodayWord(true); }}
                      className="text-xs px-2 py-1 border rounded-full text-gray-700 hover:bg-gray-100 border-gray-300"
                      title="เลือกเป็นวันนี้"
                    >
                      Today
                    </button>
                  </div>
                </div>

                <div className="h-px bg-gray-200 my-3" />

                {/* แถวหัวข้อเลือกเวลา + ปุ่มล้าง */}
                <div className="flex items-center justify-between">
                  <div className="text-sm font-medium text-gray-900">Select Available Slots (:00 :20 :40)</div>
                  <button
                    type="button"
                    onClick={clearAllSlots}
                    className="text-xs px-2 py-1 border rounded-full text-gray-700 hover:bg-gray-100 border-gray-300"
                    title="ล้างเวลา"
                  >
                    Clear all
                  </button>
                </div>

                <div className="mt-3 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-3">
                  {HOURS.map((h) => {
                    const full = isHourFull(h);
                    const selectedMins = new Set(slotSel[h] || []);
                    return (
                      <div key={h} className="border rounded-xl p-3 bg-white">
                        <div className="flex items-center justify-between">
                          <div className="text-sm font-semibold">{pad2(h)}:00</div>
                          <button
                            type="button"
                            onClick={() => toggleFullHour(h)}
                            className={`text-[11px] px-2 py-1 rounded-full border ${full ? 'bg-black text-white border-black' : 'border-gray-300 text-gray-700 hover:bg-gray-100'}`}
                            title="ทั้งชั่วโมง"
                            aria-pressed={full}
                          >
                            Entire hour
                          </button>
                        </div>

                        <div className="mt-2 flex gap-2">
                          {MINUTES.map((m) => {
                            const sel = selectedMins.has(m);
                            return (
                              <button
                                key={m}
                                type="button"
                                onClick={() => toggleMinute(h, m)}
                                className={`flex-1 px-2 py-2 text-sm rounded-lg border transition ${sel ? 'bg-black text-white border-black' : 'bg-white text-gray-800 border-gray-300 hover:bg-gray-100'}`}
                                aria-pressed={sel}
                              >
                                {toTime(h, m)}
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="mt-3 text-xs text-gray-600">
                  * When all <span className="font-medium">:00 :20 :40</span> within any hour are selected, the system will automatically summarize it as <span className="font-medium">HH:00 - HH:40 </span> 
                   If multiple consecutive hours are selected, they will be summarized as a longer range <span className="font-medium">13:00 - 14:40</span>
                </div>
              </div>

              {/* Preview */}
              <div className="border rounded-xl p-4 bg-gray-50 border-gray-200">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <div className="text-sm font-medium text-gray-900">Preview</div>
                    {/* Toggle ภาษา */}
                    <div className="flex items-center gap-1 ml-2">
                      <button
                        type="button"
                        onClick={() => setPreviewLang('TH')}
                        className={`px-2 py-0.5 text-[11px] rounded-full border ${previewLang === 'TH' ? 'bg-black text-white border-black' : 'border-gray-300 text-gray-700 hover:bg-gray-100'}`}
                        aria-pressed={previewLang === 'TH'}
                        title="ข้อความภาษาไทย"
                      >
                        ไทย
                      </button>
                      <button
                        type="button"
                        onClick={() => setPreviewLang('EN')}
                        className={`px-2 py-0.5 text-[11px] rounded-full border ${previewLang === 'EN' ? 'bg-black text-white border-black' : 'border-gray-300 text-gray-700 hover:bg-gray-100'}`}
                        aria-pressed={previewLang === 'EN'}
                        title="English for Foreigner"
                      >
                        English for Foreigner
                      </button>
                    </div>
                  </div>

                  <button
                    onClick={copySlots}
                    className="px-3 py-1 text-xs rounded-full border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                    title="คัดลอกตามภาษาที่แสดง"
                  >
                    Copy
                  </button>
                </div>
                <textarea
                  rows={12}
                  readOnly
                  value={visiblePreview}
                  className="w-full border rounded-lg px-3 py-2 text-sm bg-white"
                />
              </div>
            </div>

            {/* Footer actions */}
            <div className="mt-4 flex items-center justify-end gap-3">
              <button
                onClick={() => setActiveToolId(null)}
                className="px-4 py-1 text-sm rounded-full border border-gray-300 text-gray-700 hover:bg-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={sendSlots}
                disabled={!userId || slotsSending}
                className={`px-4 py-1 text-sm rounded-full transition ${!userId || slotsSending ? 'bg-gray-300 text-white cursor-not-allowed' : 'bg-black text-white hover:opacity-90'
                  }`}
                title={!userId ? 'ยังไม่มี userId ลูกค้าในหน้านี้' : 'ส่งข้อความตามภาษาที่แสดงใน Preview ไป LINE ลูกค้า'}
              >
                {slotsSending ? 'Sending…' : 'Send'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ---------------- PAYMENT-HELPER MODAL ---------------- */}
      {activeToolId === 'PAYMENT-HELPER' && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-xl w-[96vw] max-w-[1080px] p-5 max-h-[92vh] flex flex-col">
            {/* Header inside modal */}
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="text-sm font-semibold">Payment Helper</div>
                <div className="text-xs text-gray-500">คำนวณส่วนลดตาม % และเฉลี่ย Cash Voucher ต่อรายการ</div>
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setActiveToolId(null)}
                  className="px-2 py-1 text-xs rounded-full border border-gray-300 text-gray-600 hover:bg-gray-100"
                >
                  ✕ Close
                </button>
              </div>
            </div>

            {/* Scrollable content */}
            <div className="flex-1 overflow-y-auto mt-4 space-y-5 pr-1">
              {/* Controls */}
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                <div className="border rounded-xl p-4 bg-gray-50 border-gray-200">
                  <label className="block text-xs text-gray-600 mb-1">จำนวนรายการ (สูงสุด 8)</label>
                  <select
                    value={itemsCount}
                    onChange={(e) => setItemsCount(Math.max(1, Math.min(8, Number(e.target.value))))}
                    className="w-full border rounded-lg px-3 py-2 text-sm bg-white"
                  >
                    {Array.from({ length: 8 }, (_, i) => i + 1).map(n => (
                      <option key={n} value={n}>{n}</option>
                    ))}
                  </select>
                </div>

                {/* Cash Vouchers (toggle) */}
                <div className="lg:col-span-2 border rounded-xl p-4 bg-gray-50 border-gray-200">
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="text-sm font-medium text-gray-900">Cash Voucher (สูงสุด 3 ช่อง)</div>
                      {!showVouchers && (
                        <div className="text-xs text-gray-600 mt-0.5">
                          ซ่อนอยู่ — กด “แสดง” เพื่อกรอก Voucher (ไม่ถูกนำไปคำนวณเมื่อซ่อน)
                        </div>
                      )}
                    </div>
                    <button
                      type="button"
                      onClick={() => setShowVouchers(v => !v)}
                      className="text-xs px-2 py-1 border rounded-full text-gray-700 hover:bg-gray-100 border-gray-300"
                    >
                      {showVouchers ? 'Hide' : 'Show'}
                    </button>
                  </div>

                  {showVouchers && (
                    <>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-3">
                        {/* Voucher #1 */}
                        <div className="border rounded-xl p-3 bg-white">
                          <input
                            type="text" inputMode="decimal" pattern="[0-9]*[.,]?[0-9]*"
                            placeholder="ยอด Voucher #1"
                            value={voucher1}
                            onChange={(e) => setVoucher1(sanitizeDecimalInput(e.target.value))}
                            className="w-full border rounded-lg px-3 py-2 text-sm"
                          />
                          <input
                            type="text"
                            placeholder="Voucher Code #1 (ถ้ามี)"
                            value={voucher1Code}
                            onChange={(e) => setVoucher1Code(e.target.value)}
                            className="w-full border rounded-lg px-3 py-2 text-sm mt-2"
                          />
                        </div>

                        {/* Voucher #2 */}
                        <div className="border rounded-xl p-3 bg-white">
                          <input
                            type="text" inputMode="decimal" pattern="[0-9]*[.,]?[0-9]*"
                            placeholder="ยอด Voucher #2"
                            value={voucher2}
                            onChange={(e) => setVoucher2(sanitizeDecimalInput(e.target.value))}
                            className="w-full border rounded-lg px-3 py-2 text-sm"
                          />
                          <input
                            type="text"
                            placeholder="Voucher Code #2 (ถ้ามี)"
                            value={voucher2Code}
                            onChange={(e) => setVoucher2Code(e.target.value)}
                            className="w-full border rounded-lg px-3 py-2 text-sm mt-2"
                          />
                        </div>

                        {/* Voucher #3 */}
                        <div className="border rounded-xl p-3 bg-white">
                          <input
                            type="text" inputMode="decimal" pattern="[0-9]*[.,]?[0-9]*"
                            placeholder="ยอด Voucher #3"
                            value={voucher3}
                            onChange={(e) => setVoucher3(sanitizeDecimalInput(e.target.value))}
                            className="w-full border rounded-lg px-3 py-2 text-sm"
                          />
                          <input
                            type="text"
                            placeholder="Voucher Code #3 (ถ้ามี)"
                            value={voucher3Code}
                            onChange={(e) => setVoucher3Code(e.target.value)}
                            className="w-full border rounded-lg px-3 py-2 text-sm mt-2"
                          />
                        </div>
                      </div>

                      <div className="mt-2 text-xs text-gray-700">
                        ยอดรวม Cash Voucher: <span className="font-medium">{fmt(voucherTotal)}</span>
                        {voucherTotal > 0 && (
                          <span> • กระจายครบถ้วน (รายการท้ายรับส่วนต่าง)</span>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>

              {/* Campaigns (toggle) */}
              <div className="border rounded-xl p-4 bg-gray-50 border-gray-200">
                <div className="flex items-center justify-between">
                  <div className="text-sm font-medium text-gray-900">Campaign (สูงสุด 3 ช่อง)</div>
                  <button
                    type="button"
                    onClick={() => setShowCampaigns(v => !v)}
                    className="text-xs px-2 py-1 border rounded-full text-gray-700 hover:bg-gray-100 border-gray-300"
                  >
                    {showCampaigns ? 'Hide' : 'Show'}
                  </button>
                </div>

                {showCampaigns && (
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-3">
                    {/* Camp 1 */}
                    <div className="border rounded-xl p-3 bg-white space-y-2">
                      <input
                        type="text" placeholder="Campaign Name #1"
                        value={camp1Name} onChange={(e) => setCamp1Name(e.target.value)}
                        className="w-full border rounded-lg px-3 py-2 text-sm"
                      />
                      <input
                        type="text" placeholder="Campaign Code #1"
                        value={camp1Code} onChange={(e) => setCamp1Code(e.target.value)}
                        className="w-full border rounded-lg px-3 py-2 text-sm"
                      />
                    </div>
                    {/* Camp 2 */}
                    <div className="border rounded-xl p-3 bg-white space-y-2">
                      <input
                        type="text" placeholder="Campaign Name #2"
                        value={camp2Name} onChange={(e) => setCamp2Name(e.target.value)}
                        className="w-full border rounded-lg px-3 py-2 text-sm"
                      />
                      <input
                        type="text" placeholder="Campaign Code #2"
                        value={camp2Code} onChange={(e) => setCamp2Code(e.target.value)}
                        className="w-full border rounded-lg px-3 py-2 text-sm"
                      />
                    </div>
                    {/* Camp 3 */}
                    <div className="border rounded-xl p-3 bg-white space-y-2">
                      <input
                        type="text" placeholder="Campaign Name #3"
                        value={camp3Name} onChange={(e) => setCamp3Name(e.target.value)}
                        className="w-full border rounded-lg px-3 py-2 text-sm"
                      />
                      <input
                        type="text" placeholder="Campaign Code #3"
                        value={camp3Code} onChange={(e) => setCamp3Code(e.target.value)}
                        className="w-full border rounded-lg px-3 py-2 text-sm"
                      />
                    </div>
                  </div>
                )}
              </div>

              {/* Items Table */}
              <div className="border rounded-xl p-4 bg-gray-50 border-gray-200">
                <div className="text-sm font-medium text-gray-900 mb-2">รายการคำนวณ</div>

                {/* header: แถวตั้งแต่ sm ขึ้นไป */}
                <div className="hidden sm:grid grid-cols-12 text-[11px] text-gray-600 px-2">
                  <div className="col-span-1" >#</div>
                  <div className="col-span-2">ราคา</div>
                  <div className="col-span-2">ส่วนลด (%)</div>
                  <div className="col-span-3">ประเภทส่วนลด</div>
                  <div className="col-span-2">ส่วนลดจาก %</div>
                  <div className="col-span-2">ส่วนลดรวม (+Voucher)</div>
                </div>

                <div className="space-y-3 mt-2">
                  {visibleItems.map((it, idx) => {
                    const r = computedRows[idx];
                    return (
                      <div
                        key={idx}
                        className="grid grid-cols-1 sm:grid-cols-12 gap-3 items-start border rounded-xl p-3 bg-white"
                      >
                        {/* # ซ้ายสุด */}
                        <div className="sm:col-span-1 text-xs text-gray-500 pt-2">#{idx + 1}</div>

                        {/* ราคา */}
                        <div className="sm:col-span-2">
                          <label className="block sm:hidden text-[11px] text-gray-600 mb-1">ราคา</label>
                          <input
                            type="text" inputMode="decimal" pattern="[0-9]*[.,]?[0-9]*"
                            value={it.price}
                            onChange={(e) => {
                              const next = [...items];
                              next[idx] = { ...next[idx], price: sanitizeDecimalInput(e.target.value) };
                              setItems(next);
                            }}
                            className="w-full border rounded-lg px-3 py-2 text-sm"
                            placeholder="0.00"
                          />
                        </div>

                        {/* ส่วนลด (%) */}
                        <div className="sm:col-span-2">
                          <label className="block sm:hidden text-[11px] text-gray-600 mb-1">ส่วนลด (%)</label>
                          <select
                            value={String(it.pct)}
                            onChange={(e) => {
                              const next = [...items];
                              next[idx] = { ...next[idx], pct: e.target.value };
                              setItems(next);
                            }}
                            className="w-full border rounded-lg px-3 py-2 text-sm bg-white"
                          >
                            <option value="">—</option>
                            {PCT_OPTIONS.map(p => <option key={p} value={p}>{p}%</option>)}
                          </select>
                        </div>

                        {/* ประเภทส่วนลด */}
                        <div className="sm:col-span-3">
                          <label className="block sm:hidden text-[11px] text-gray-600 mb-1">ประเภทส่วนลด</label>
                          <select
                            value={it.pctLabel}
                            onChange={(e) => {
                              const next = [...items];
                              next[idx] = { ...next[idx], pctLabel: e.target.value };
                              setItems(next);
                            }}
                            className="w-full border rounded-lg px-3 py-2 text-sm bg-white"
                            title="ประเภทส่วนลด"
                          >
                            {DISCOUNT_LABELS.map(label => (
                              <option key={label} value={label}>{label || '— ประเภทส่วนลด —'}</option>
                            ))}
                          </select>
                        </div>

                        {/* ส่วนลดจาก % */}
                        <div className="sm:col-span-2">
                          <label className="block sm:hidden text-[11px] text-gray-600 mb-1">ส่วนลดจาก %</label>
                          <div className="w-full border rounded-lg px-3 py-2 text-sm bg-gray-50">
                            {fmt(r.pctDiscount)}
                          </div>
                        </div>

                        {/* ส่วนลดรวม (+Voucher) */}
                        <div className="sm:col-span-2">
                          <label className="block sm:hidden text-[11px] text-gray-600 mb-1">ส่วนลดรวม (+Voucher)</label>
                          <div className="w-full border rounded-lg px-3 py-2 text-sm bg-gray-50">
                            {fmt(r.totalDiscount)}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Totals Box + Deposit */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {/* กล่องเดียวรวม 4 บรรทัด */}
                <div className="border rounded-xl p-4 bg-gray-50 border-gray-200 text-sm">
                  <div className="flex items-center justify-between">
                    <span className="text-gray-900">ยอดก่อนลด</span>
                    <span className="font-semibold text-gray-900">{fmt(totals.sumPrice)} บาท</span>
                  </div>
                  <div className="flex items-center justify-between mt-1">
                    <span className="text-gray-900">ส่วนลด จาก % รวม</span>
                    <span className="font-semibold text-gray-900">{fmt(totals.sumPctDiscount)} บาท</span>
                  </div>
                  <div className="flex items-center justify-between mt-1">
                    <span className="text-gray-900">Cash Voucher รวม</span>
                    <span className="font-semibold text-gray-900">{fmt(totals.sumVoucherAlloc)} บาท</span>
                  </div>
                  <div className="h-px bg-gray-200 my-3" />
                  <div className="flex items-center justify-between">
                    <span className="text-gray-900">ยอดสุทธิ</span>
                    <span className="font-semibold text-gray-900">{fmt(totals.sumNet)} บาท</span>
                  </div>
                </div>

                {/* โอนจองมาแล้ว */}
                <label className="flex items-center gap-2 border rounded-xl p-4 bg-gray-50 border-gray-200 text-sm cursor-pointer">
                  <input
                    type="checkbox"
                    checked={depositPaid}
                    onChange={(e) => {
                      setDepositPaid(e.target.checked);
                      setCashPayInput('');
                      setCreditPayInput('');
                    }}
                  />
                  <span className="text-gray-900">
                    โอนจองมาแล้ว ({DEPOSIT_AMOUNT.toLocaleString()} บาท)
                  </span>
                </label>
              </div>

              {/* Payment Summary & Notes */}
              <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                {/* ชำระโดย: กิน 3 ส่วน */}
                <div className="md:col-span-3 border rounded-2xl p-4 bg-gray-50 border-gray-200">
                  <div className="text-sm font-semibold text-gray-900 mb-3">ชำระโดย</div>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-700">ยอดสุทธิที่ต้องชำระ</span>
                      <span className="font-semibold text-gray-900">{fmt(totals.sumNet)}</span>
                    </div>

                    {depositPaid && (
                      <>
                        <div className="flex justify-between">
                          <span className="text-gray-700">โอนจอง (กรอกในช่องอื่นๆ)</span>
                          <span className="font-semibold text-gray-900">{fmt(DEPOSIT_AMOUNT)}</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-900">ยอดชำระวันจริง (หลังหักโอนจอง)</span>
                          <span className="font-semibold text-gray-900">{fmt(totals.netAfterDeposit)}</span>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-2 pt-2">
                          <div className="border rounded-lg p-2 bg-white">
                            <div className="text-xs text-gray-600 mb-1">Cash</div>
                            <input
                              type="text" inputMode="decimal" pattern="[0-9]*[.,]?[0-9]*"
                              value={cashPayInput}
                              onChange={(e) => setCashPayInput(sanitizeDecimalInput(e.target.value))}
                              placeholder={fmt(0)}
                              className="w-full border rounded px-2 py-1 text-sm"
                            />
                          </div>
                          <div className="border rounded-lg p-2 bg-white">
                            <div className="text-xs text-gray-600 mb-1">Transfer (Auto)</div>
                            <div className="text-sm font-medium">{fmt(transferPay)}</div>
                          </div>
                          <div className="border rounded-lg p-2 bg-white">
                            <div className="text-xs text-gray-600 mb-1">Credit Card</div>
                            <input
                              type="text" inputMode="decimal" pattern="[0-9]*[.,]?[0-9]*"
                              value={creditPayInput}
                              onChange={(e) => setCreditPayInput(sanitizeDecimalInput(e.target.value))}
                              placeholder={fmt(0)}
                              className="w-full border rounded px-2 py-1 text-sm"
                            />
                          </div>
                        </div>

                        {overpay && (
                          <div className="text-xs text-red-600 mt-1">
                            ยอด เงินสด + เครดิต เกินยอดชำระวันจริง โปรดปรับตัวเลขให้ไม่เกิน {fmt(totals.netAfterDeposit)}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>

                {/* สรุปหมายเหตุ: กิน 2 ส่วน */}
                <div className="md:col-span-2 border rounded-2xl p-4 bg-gray-50 border-gray-200">
                  <div className="flex items-center justify-between mb-3">
                    <div className="text-sm font-semibold text-gray-900">สรุปหมายเหตุ</div>
                    <button
                      onClick={copyNotes}
                      disabled={!notesText}
                      className="px-3 py-1 text-xs rounded-full border border-gray-300 text-gray-700 hover:bg-gray-100 disabled:opacity-50"
                    >
                      Copy
                    </button>
                  </div>
                  <textarea
                    rows={8}
                    readOnly
                    value={notesText}
                    className="w-full border rounded-lg px-3 py-2 text-sm bg-white max-h-[32vh] overflow-auto"
                    placeholder="พิมพ์ข้อมูลเพื่อสร้างสรุปหมายเหตุ"
                  />
                </div>
              </div>
            </div>

            {/* Footer actions */}
            <div className="mt-4 flex items-center justify-end gap-3">
              <button
                onClick={() => setActiveToolId(null)}
                className="px-4 py-1 text-sm rounded-full border border-gray-300 text-gray-700 hover:bg-gray-100"
              >
                Close
              </button>
              <button
                onClick={sendSlots}
                disabled={!userId || slotsSending}
                className={`px-4 py-1 text-sm rounded-full transition ${!userId || slotsSending ? 'bg-gray-300 text-white cursor-not-allowed' : 'bg-black text-white hover:opacity-90'
                  }`}
                title={!userId ? 'ยังไม่มี userId ลูกค้าในหน้านี้' : 'ส่งข้อความตามภาษาที่แสดงใน Preview ไป LINE ลูกค้า'}
              >
                {slotsSending ? 'Sending…' : 'Send'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Success Toast */}
      {toast && (
        <div className="fixed bottom-5 left-1/2 -translate-x-1/2 z-[60]">
          <div className="bg-white shadow-xl rounded-full px-4 py-2 border border-gray-200 text-sm text-gray-800">
            {toast}
          </div>
        </div>
      )}
    </div>
  );
}
